import { FC } from 'react';
import AttributeHeader, { AttributeHeaderProps } from './AttributeHeader';
import CardSelect from 'components/CardSelect/CardSelect';

interface CardListProps extends AttributeHeaderProps {
  onClick: (item: unknown, index?: number) => void;
  options: CardListOptionType[];
  selected: string | null;
}

export type CardListOptionType = {
  id: string;
  title: string;
  body?: string;
  item?: unknown;
};

const CardList: FC<CardListProps> = ({
  onClick,
  options,
  selected,
  ...attributeHeaderProps
}) => {
  return (
    <>
      <AttributeHeader {...attributeHeaderProps} />
      <div className="grid grid-cols-1 gap-4 pl-6 pr-4">
        {options.map((option, index) => (
          <CardSelect
            variant="blue"
            key={`${index}_${JSON.stringify(option?.item)}`}
            title={option.title}
            body={option.body}
            type="radio"
            selected={selected === option.id}
            onSelect={() => {
              onClick(option.item || option.id, index);
            }}
          />
        ))}
      </div>
    </>
  );
};

export default CardList;
